// External.
import * as Lyra from "@lyrasearch/lyra";

// Local.
import type { Documentation } from "../services/document-service";

export interface DocumentationIndex {
    match: (term: string) => Documentation[];
}

const DocumentSchema = {
    name: "string",
    ext: "string",
    title: "string",
    description: "string",
    keywords: "string",
} as const;

function create(documents: Documentation[]): DocumentationIndex {
    // Set of keys.
    const documentLookup = new Map<string, Documentation>();

    // Generate search database.
    const db = Lyra.create({ schema: DocumentSchema });

    // Load initial search state.
    documents.forEach((doc) => {
        const { name, ext, title, description, keywords } = doc;
        Lyra.insert(db, {
            name,
            ext,
            title,
            description,
            keywords: keywords.join(" "),
        });
        documentLookup.set(ext, doc);
    });

    const index: DocumentationIndex = {
        match(term: string): Documentation[] {
            const result = Lyra.search(db, {
                term,
                properties: "*",
            });

            return result.hits.map((hit) => {
                return documentLookup.get(hit.ext) as Documentation;
            });
        },
    } as const;

    return index;
}

const DocumentationDatabase = {
    build(documents: Documentation[]): DocumentationIndex {
        return create(documents);
    },
} as const;

export { DocumentationDatabase };
